import axios from 'axios';
import {LoadingWrap, scrollToTop} from './util.js';
import {modalFX} from './modalFX.js'

export  const  modalHttpSample = {
props:{},
init() {
  const modalHttpSamples = document.querySelectorAll('[data-target="modal-sample2"]');
  modalHttpSamples.forEach((el) => {
    el.addEventListener('click', async (e) => {
      await LoadingWrap(()=>this.event(e));
      this.modalOpen(e);
    });
  });
},
modalOpen(e){
  const target = e.target.getAttribute('data-target');

    const modal = modalFX();
    modal.openModal(target);

  //modal.classList.add('is-active');

},
async event(e) {
  // const param = {
  //   "FNP_CD" : e.target.dataset.cd,
  //   "FNP_slug": e.target.dataset.slug,
  // }
  // console.log(param);
  const url = `https://jsonplaceholder.typicode.com/users`;
  const response = await axios.get(url);
    console.log(`response`,response);
    this.props = {
      LS: response.data,
    }
    console.log(`props`,this.props);
    const target = document.getElementById(`modal-sample2-data`);
    target.innerHTML = await this.render();
    const modalContent = target.closest(`div.modal-content`);
    scrollToTop(modalContent);

},
async render(){

  return `<h3>モーダル通信サンプル</h3>
  <table class="table is-striped is-hoverable is-fullwidth">
    <tbody>

  ${this.props.LS.map(v=>{
    return `<tr>
      <td>${v.id}</td>
      <td>${v.name}</td>
      <td>${v.username}</td>
      <td>${v.email}</td>
    </tr>`
  }).join(``)}
  </tbody>
  </table>`
}


}


